import React from 'react';
import type { RangeValue } from '../RangeInput';
import { RangeInput } from '../RangeInput';
import { usePriceRange } from './PriceRange.controller';
import { useTranslation } from '@shared/core';

type PriceRangeArgs = {
  showSlider?: boolean;
  value: RangeValue;
  onChange?: (value: RangeValue) => void;
};

const PriceRange: React.FC<PriceRangeArgs> = ({ value, onChange }) => {
  const { currentValue, handleChange } = usePriceRange({ value, onChange });
  const { tq } = useTranslation('catalogRegistry');
  return (
    <RangeInput
      unit={'$'}
      minLabel={tq`Min`}
      maxLabel={tq`Max`}
      minPlaceholder={'0'}
      maxPlaceholder={'1000+'}
      minValue={0}
      value={currentValue}
      onChange={handleChange}
    />
  );
};

export { PriceRange };
export type { PriceRangeArgs };
